import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PersonSearchService } from '../_services/person-search.service';

type DisplayMode = 'gif' | 'youtube';
type TourItem = { tour_id?: number, tour_config?: { subtitle?: string, icon?: string, gif_url?: string, allow_skip?: boolean, allow_video?: boolean, yt_video_id?: string }, module?: string, title: string, position?: number, isactive?: boolean };

@Component({
    selector: 'app-platform-tour-modal',
    templateUrl: './platform-tour-modal.component.html',
    styleUrls: ['./platform-tour-modal.component.scss'],
    standalone: false
})

export class PlatformTourModalComponent implements OnInit {

  /**
   * Prop to indicate which page/position to jump to out of all items
   */
  @Input() pageToJump: number = null;

  constructor(private activeModal: NgbActiveModal, private personSearchService: PersonSearchService) {
    this.getAllToursData();
  }

  /**
   * Carousel component config
   */
  carouselConfig: any = {
    numVisible: 1,
    numScroll: 1,
    circular: false,
    showNavigators: false
  }
  /**
   * Store all tour items
   */
  tourItems: TourItem[] = [];
  /**
   * Current display mode - gif or youtube-player
   */
  displayMode: DisplayMode = 'gif';
  /**
   * Store current page
   */
  currentPage: number = 0;
  /**
   * Flag to keep loading status before loading assets
   */
  isLoading: boolean = true;
  /**
   * Flag to track loading status of tour data API
   */
  isAPICallComplete: boolean = false;

  ngOnInit() {
    if(this.pageToJump !== null) {
      this.currentPage = this.pageToJump;
    }
  }

  ngAfterViewChecked(){
    // remove unwanted elements from carousel component
    document.querySelector('.tour-carousel > div.p-carousel.p-carousel-horizontal')?.classList.remove('p-component');
  }

  /**
   * Computed property to know if current page is the last
   */
  get reachedLastPage() {
    return this.currentPage === (this.tourItems.length - 1);
  }

  /**
   * Computed property to know if current page is the last
   */
  get isFirstPage() {
    return this.currentPage === 0;
  }

  /**
   * Fetch all tours data via service
   */
  getAllToursData() {
    this.isAPICallComplete = false;
    this.personSearchService.getPersonSearchTours().subscribe((res: any) => {
      if(res && res.status === 'success') {
        this.isAPICallComplete = true;
        this.tourItems = res.data;
      } else {
        console.log("getPersonSearchTours failure res", res);
      }
    }, (err: any) => {
      console.log("getPersonSearchTours failure err", err);
    })
  }

  /**
   * Page change event handler to toggle between display modes automatically
   * @param event
   */
  pageChangeEventHandler(event: any) {
    if(this.displayMode === 'youtube') this.switchDisplayMode('gif');
    if(event && Reflect.has(event, 'page')) this.currentPage = event.page;
  }

  /**
   * Handler method for page navigations
   * @param action
   */
  setPage(action: 'previous' | 'next') {
    if(action === 'previous') {
      this.currentPage = (this.currentPage - 1 + this.tourItems.length) % this.tourItems.length;
    } else if(action === 'next') {
      this.currentPage = (this.currentPage + 1 + this.tourItems.length) % this.tourItems.length;
    }
  }

  /**
   * Switch between display modes
   * @param displayMode
   */
  switchDisplayMode(displayMode: DisplayMode) {
    if(!(displayMode === 'gif' || displayMode === 'youtube')) return;

    this.displayMode = displayMode;
  }

  /**
   * On-load event listener to handle loading status
   */
  onLoad() {
    this.isLoading = false;
  }

  /**
   * Close current modal
   * @param message
   */
  closeActiveModal(message: string) {
    const returnMessage = this.tourItems.length ? message : 'NO_UPDATE';
    this.activeModal.close(returnMessage);
  }

}
